import { render, staticRenderFns } from "./UpgradeUserLicence.vue?vue&type=template&id=d5d389c4&scoped=true"
import script from "./UpgradeUserLicence.vue?vue&type=script&lang=js"
export * from "./UpgradeUserLicence.vue?vue&type=script&lang=js"
import style0 from "./UpgradeUserLicence.vue?vue&type=style&index=0&id=d5d389c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d389c4",
  null
  
)

export default component.exports